<span class="indicator" [class]="StyleClass" [uTooltip]="name">
  <span [style.width]="size" [style.height]="size" class="indicator-dot" [style.background]="color ? 'var(--' + color + ')' : ''"></span>
  <div class="indicator-dot-wrapper" [uTooltip]="name"></div>
</span>
